import { executeRequest, Request } from '@jfs/network'
import { actionMenuStrings } from '../../src/data/static/strings'
import { RootStore } from '../../src/data/store'
import { apiTypes, geRequestDateTimeRoundOff } from '../../src/util/util'
import { CampaignSummaryParser } from '../network/parsers/CampaignSumaryParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return CampaignSummaryParser(respData?.data?.distribution)
}

const getCampaignsSummary = (req: any, tokens: any) => {
  const isCustomRange = RootStore.campaigns.selectedDateInfo.dateLabel === actionMenuStrings.customDate

  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.getCampaignsSummary}`,
    method: 'POST',
    cache: false,
    body: isCustomRange ? req : geRequestDateTimeRoundOff(req, RootStore.campaigns.selectedDateInfo, apiTypes.CAMPAIGN),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getCampaignsSummary }
